import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from './ui/dialog';
import { useCallback, useEffect, useState } from 'react';
import { Button } from './ui/button';
import { useRouter } from 'next/router';

// Impostata da signin.js al clic su "Prova la demo": il dialogo compare a ogni
// ingresso in demo, senza dipendere dal localStorage della visita guidata.
export const CHIAVE_BENVENUTO = 'dimora.benvenuto-demo';

/**
 * Orientamento all'ingresso in demo: dichiara l'ambiente dimostrativo e
 * propone la visita guidata. Montato in Application, si apre solo quando
 * trova il flag lasciato dal bottone "Prova la demo".
 */
export default function BenvenutoDemo() {
  const router = useRouter();
  const [aperto, setAperto] = useState(false);

  useEffect(() => {
    let flag = null;
    try {
      flag = sessionStorage.getItem(CHIAVE_BENVENUTO);
    } catch (e) {
      return;
    }
    const percorso = String(router.asPath || '').split('?')[0];
    if (flag === '1' && /\/dashboard\/?$/.test(percorso)) {
      try {
        sessionStorage.removeItem(CHIAVE_BENVENUTO);
      } catch (e) {
        /* niente: il dialogo si apre comunque */
      }
      setAperto(true);
    }
  }, [router.asPath]);

  const avviaGiro = useCallback(() => {
    setAperto(false);
    // Piccola attesa: il dialogo deve chiudersi prima che il fumetto compaia.
    setTimeout(() => {
      if (typeof window.dimoraRivediVisita === 'function') {
        window.dimoraRivediVisita();
      } else if (window.GDPTour) {
        window.GDPTour.dimentica();
        window.GDPTour.avvia();
      }
    }, 300);
  }, []);

  return (
    <Dialog open={aperto} onOpenChange={setAperto}>
      <DialogContent className="max-w-md" data-cy="benvenutoDemo">
        <DialogHeader>
          <DialogTitle>Ambiente dimostrativo</DialogTitle>
          <DialogDescription className="pt-1 text-base">
            Dati di esempio, modificabili liberamente. Immobili, inquilini,
            affitti e ricevute sono già popolati: puoi esplorare tutto senza
            rompere niente.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2 pt-2 sm:flex-row sm:justify-end">
          <Button
            variant="outline"
            data-cy="esploraLiberamente"
            onClick={() => setAperto(false)}
          >
            Esplora liberamente
          </Button>
          <Button data-cy="faiGiroGuidato" onClick={avviaGiro}>
            Fai il giro guidato
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
